import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import type {DateFormattingStrategyData} from '../../types/date-formatting-strategy-data.type';
import {DateFormattingStrategyService} from '../../DateFormattingStrategyService';

import {makeLogger} from '../../../../logger/logger';

const {err} = makeLogger({pathToCurrentFile: 'components/strategies/Strategies.tsx'});

@Service({id: 'dateFormattingFallbackStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<DateFormattingStrategyService> {

  build(details: DateFormattingStrategyData): DateFormattingStrategyService {
      return new DateFormattingStrategyFallback(details);
  }
}

export class DateFormattingStrategyFallback extends DateFormattingStrategyService {
  details;

  constructor(details: DateFormattingStrategyData) {
      super();
      this.details = details;
  }

  private formatDate (dateString:string, locale?:string) {
      try {
        const options: any = { year: 'numeric', month: 'long', day: 'numeric' };//eslint-disable-line @typescript-eslint/no-explicit-any
        const parsedDate = new Date(dateString);
        return (
          new Intl.DateTimeFormat(
            locale ?? 'default',
            options
          ).format(parsedDate)

        );
      } catch (ignored) {
        err(`Unable to format date from following string: ${dateString}`);
        return '';
      }
  }

  private getLocale (country:String, language:String) {
      if(country?.length == 2 && language?.length == 2) {
        return `${language}-${country.toUpperCase()}`;
      } else {
        err(`Unable to display date in localized format. Country: ${country}, language: ${language}`);
      }

  }
  format(date: string, country:string, language:string):string {
      return this.formatDate(date, this.getLocale(country, language));
  }
}
